<template>
  <div class="tabs_box">
    <div
      :class="{ active_tab: active === item.name }"
      v-for="(item, index) in tabList"
      :key="index"
      @click="handleTab(item.name)"
    >
      {{ item.tab }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    active: Number
  },
  data() {
    return {
      tabList: [
        { tab: this.$t('手机'), name: 0 },
        { tab: this.$t('邮箱'), name: 1 }
      ]
    }
  },
  methods: {
    handleTab(name) {
      this.$emit('update:active', name)
    }
  }
}
</script>
<style lang="less" scoped>
.tabs_box {
  // margin-top: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
  div {
    padding-bottom: 2px;
    cursor: pointer;
  }
  div:last-child {
    margin-left: 20px;
  }
  // 动态控制 tab 样式
  .active_tab {
    font-weight: 600;
    color: #1c1b1b;
    border-bottom: 2px solid #c02e21;
  }
}
</style>
